<template>
  <div class="my-question-box">
    <div class="my-question-cont">
      <ul class="type-list">
        <li v-for="item in typeList" :class="{active:item.id === type}" @click="changeType(item)" :key="item.id">{{item.name}}</li>
      </ul>
      <ul v-show="questionList && questionList.length > 0" class="content-list">
        <li v-for="item in questionList" :key="item.id" @click="toDetails(item)">
          <div class="question-title">
            <p>{{item.askDesc}}</p>
            <span class="time">{{item.askTimeStr}}</span>
          </div>
          <div class="answer-cont">
            <div class="left">
              <div class="answer-tips" :class="item.askReplys[0].isAccept ? 'accept-tips' : item.askReplys[0].isRecommend ? 'recommend-tips':''" v-if="item.replyCount">
                <p><i>{{item.askReplys[0].isAccept ? '采纳回答' : item.askReplys[0].isRecommend ? '推荐回答' : '最新回答'}}</i></p>
              </div>
              <div class="answer-tips" v-else>
                <p><i>暂无回答</i></p></div>
            </div>
            <p class="info" v-if="item.replyCount" :title="ToText(item.askReplys[0].content)"><span>{{item.askReplys[0].replierName}}：</span>{{ToText(item.askReplys[0].content)}}</p>

          </div>
          <div class="more-answer">
            <span>{{item.replyCount}}个回答</span>
            <span>{{item.browseCount}}浏览</span>
            <span class="barrier-info">{{item.courseName}}&nbsp;&nbsp;/&nbsp;&nbsp;{{item.chapterName}}&nbsp;&nbsp;/&nbsp;&nbsp;{{item.barrierName}}</span>
          </div>
        </li>
      </ul>
      <div class="pagination-box" v-show="pageData.total > 10">
        <el-pagination
          background
          @current-change="handleCurrentChange"
          :current-page.sync="pageData.page"
          :page-size="10"
          layout="prev, pager, next, jumper"
          :total="pageData.total">
        </el-pagination>
      </div>
    </div>
    <div class="default-box" v-show="defaultFlag">
      <img src="@/image/help/icon-default-1.png" alt="">
      <p>这里还没有您的提问哦~</p>
    </div>
  </div>
</template>

<script>
import { axios } from "@/../api/init";
import { zhugeTrack } from "@/../public/public";
export default {
  name: '',
  data() {
    return {
      questionList:[],
      defaultFlag: false,
      type: 0,
      typeList:[
        {id: 0, name: '全部'},
        {id: 1, name: '未解决'},
        {id: 2, name: '已采纳'},
        {id: 3, name: '推荐'}
      ],
      pageData:{
        total:0,
        page:1,
        pageSize: 10,
      }
    }
  },
  methods:{
    // 我的提问
    async getMyQuestion(){
      let params = {
        type: this.type,
        studentId: localStorage.getItem('studentId'),
        sign: localStorage.getItem('sign'),
        page: this.pageData.page,
        pageSize: this.pageData.pageSize
      }
      let res = await axios({
        url: VUE_APP_BASE_PATH_ONLINE_APP + `/interactive-course/ask/my/asks`,
        method: "GET",
        params: params
      })
      if(res.data.status == 200){
        let result = res.data.result
        if(result.total === 0){
          this.defaultFlag = true
        }else{
          this.defaultFlag = false
        }
        this.questionList = result.list
        this.pageData.total = result.total
        if(this.type === 0){
          this.$emit('getTotal', 'q', result.total)
        }
      }else{
        this.$message.error(res.data.message)
      }
    },
    // 切换分类
    changeType(item){
      this.type = item.id
      this.getMyQuestion()
    },
    // 页数修改
    handleCurrentChange(){
      this.getMyQuestion()
      window.scrollTo(0,0)
    },
    // 点击列表
    toDetails(item){
      let url = this.$router.resolve({
        path:'/alone',
        query:{
          askId: item.id
        }
      })
      window.open(url.href,'_blank')
      // zhugeTrack('Web_我的问答-点击我的提问-提问列表',{
      //   '课程id': item.courseId,
      //   '课程名称': item.courseName,
      // })
    },
    // 富文本转为纯文本
    ToText(HTML,id){
      var input = HTML;
      var str = input.replace(/<(style|script|iframe)[^>]*?>[\s\S]+?<\/\1\s*>/gi,'').replace(/<[^>]+?>/g,'').replace(/\s+/g,' ').replace(/ /g,' ').replace(/>/g,' '); 
      if(str === ''){
        if(HTML.indexOf('<img') != -1){
          str = '图片（点击查看）'
        }
      }
      str = str.replace(/&nbsp;/g,' ')
      return str
    },
  }
}
</script>

<style lang="less" scoped>
.my-question-box{
  .my-question-cont{
    .content-list{
      margin-top: 28px;
      li{
        border-bottom: 1px solid #dce0e4;
        padding-bottom: 20px;
        margin-bottom: 20px;
        cursor: pointer;
        .question-title{
          display: flex;
          justify-content: space-between;
          p{
            max-width: calc(100% - 200px);
            font-size: 18px;
            color: #1b3056;
            line-height: 25px;
            word-break:break-all;
          }
          .time{
            line-height: 25px;
            font-size: 14px;
            color: #818896;
          }
        }

        .answer-cont{
          display: flex;
          margin-top: 13px;
          .left{
            margin-right: 10px;
            transform: translateY(3px);
            .answer-tips{
              min-height: 22px;
              p{
                width: 50px;
                height: 16px;
                display: flex;
                align-items: center;
                padding: 1px 0;
                border: 1px solid #2B3A54;
                border-radius: 4px;
                background-color: rgba(129, 136, 150, 0.1);
                i{
                  color: #2B3A54;
                  font-size: 12px;
                  line-height: 12px;
                  transform: scale(.8);
                }
              }
            }
            // 推荐
            .recommend-tips{
              p{
                border: 1px solid #e11e46;
                background-color: rgba(225, 30, 70, 0.1);
                i{
                  color: #e11e46;
                }
              }
            }
            // 采纳
            .accept-tips{
              p{
                border: 1px solid #68aa14;
                background-color: rgba(104, 170, 20, 0.1);
                i{
                  color: #68aa14;
                }
              }
            }
          }
          .info{
            line-height: 22px;
            font-size: 14px;
            color: #1b3056;
            word-break:break-all;
            text-overflow: -o-ellipsis-lastline;
            text-overflow: ellipsis;
            overflow: hidden;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            line-clamp: 2;
            -webkit-box-orient: vertical;
            span{
              font-weight: bold;
            }
          }
        }

        .more-answer{
          margin-top: 20px;
          height: 20px;
          span{
            display: block;
            float: left;
            font-size: 14px;
            color: #7D8898;
            line-height: 20px;
            margin-left: 40px;
          }
          span:nth-of-type(1){
            margin:0;
          }
          .barrier-info{
            text-align: right;
            width: 300px;
            text-overflow:ellipsis;  
            overflow: hidden;  
            white-space: nowrap
          }
          span:last-child{
            float: right;
          }
        }
      }
    }
  }
}
</style>